export const asLoadable = <TData = any, TError = any>(
  result: TData | undefined,
  error: TError | undefined,
  loading: boolean | undefined
): Loadable<TData, TError> => {
  if (result) return { result };
  if (error) return { error };
  if (loading) return { loading: true };
  return {};
};

export type Loadable<TData = any, TError = any> =
  // Unititialized
  | { loading?: false; result?: null; error?: null }
  // Loading
  | { loading: true; error?: null; result?: null }
  // Successfull
  | { loading?: false; result: TData; error?: null }
  // Failed
  | { loading?: false; error: TError; result?: null };
